export const BOX_SHADOW = 'rgb(0 0 0 / 18%) 0px 4px 8px';

